import { SAVE_KEY } from '@core/config/constants';
import type { PlayerProfileData } from '@core/types';

/**
 * Encapsula la persistencia del progreso del jugador. Hoy usa localStorage; al
 * portar a Capacitor (Play Store) se puede cambiar la implementacion interna por
 * almacenamiento nativo sin tocar el resto del juego.
 */
export class SaveService {
  public load(): PlayerProfileData | null {
    try {
      const raw = window.localStorage.getItem(SAVE_KEY);
      if (raw === null) {
        return null;
      }
      return JSON.parse(raw) as PlayerProfileData;
    } catch (error) {
      console.error('No se pudo leer el guardado del jugador.', error);
      return null;
    }
  }

  public save(data: PlayerProfileData): void {
    try {
      window.localStorage.setItem(SAVE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('No se pudo guardar el progreso del jugador.', error);
    }
  }

  public clear(): void {
    try {
      window.localStorage.removeItem(SAVE_KEY);
    } catch (error) {
      console.error('No se pudo borrar el guardado del jugador.', error);
    }
  }
}
